export default [
  {
    route: '/',
    title: 'Mural',
    icon: 'HomeIcon',
    i18n: 'Mural',
    rule: 'dashboard',
    /*
     * O influencer tem `dashboard` (o papel herda a permissão), mas não tem
     * Mural: a tela inicial dele é "Meu Painel". Esconder por papel, e não por
     * permissão, porque o admin da Hubee recebe todas as permissões — inclusive
     * as do painel — e continuaria precisando do Mural.
     */
    hideForRoles: ['influencer']
  }
]
